import { useContext } from "react";

import { WorkflowTemplateOrganisationAccessLevel } from "../../../../../../../constants";
import { WorkflowTemplateContext } from "../../WorkflowTemplateContext";
import { WorkflowTemplateStepModel } from "./models";

interface UseWorkflowTemplateStepsReturnData {
  workflowTemplateSteps: WorkflowTemplateStepModel[] | undefined;
  canAddStep?: boolean;
}

export const useWorkflowTemplateSteps = (): UseWorkflowTemplateStepsReturnData => {
  const { workflowTemplateSteps, hasAccessLevelAndCanEditTemplate } = useContext(WorkflowTemplateContext);
  return {
    workflowTemplateSteps,
    canAddStep: hasAccessLevelAndCanEditTemplate(WorkflowTemplateOrganisationAccessLevel.Contributor),
  };
};
